module.exports = __webpack_public_path__ + "static/media/florida.39fe6cdf.png";